// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"adde877c","198":"e0810945","246":"89938dd3","347":"ff015c45","771":"b218d4a5","888":"bab1939e"}[chunkId] + ".chunk.css";
};